import { PosVendaProtocoloStatus } from '../../types/posVenda';
import { statusCanonico } from './posVendaKanbanUtils';

export function slaEstaPausado(status: PosVendaProtocoloStatus | string): boolean {
  const canon = statusCanonico(String(status));
  return canon === 'AguardandoCliente' || canon === 'AguardandoTerceiro';
}
